// extracted by mini-css-extract-plugin
export default {"bottom_affix":"index_bottom_affix_EXkbU","backToTop":"index_backToTop_1-EI-"};